import { base_api } from './service';

/*interface IMetric {
	user: string;
	location: string;
	seconds: number;
	ad: string;
	info: ILabMetrics;
}*/

function getSeconds(start: Date, end: Date) {
	let time = end.getTime() - start.getTime();
	return Math.round(time / 1000);
}

class Metrics {
	appMetrics: IAppMetric[] = [];
	currentApp: IAppMetric;
	enterDate: Date = new Date();
	user: string;
	channels: string[] = [];
	participants: { id: string; name: string }[] = [];
	location = document.location.href;
	referer: string = undefined;

	constructor() {}

	startApp(name: string) {
		if (this.currentApp) {
			this.endApp();
		}

		this.currentApp = {
			startDate: new Date(),
			seconds: 0,
			name
		};

		this.appMetrics.push(this.currentApp);
	}

	endApp() {
		if (!this.currentApp) return;

		try {
			let start = <Date>this.currentApp.startDate;
			this.currentApp.startDate = start.toLocaleString();
			this.currentApp.seconds = getSeconds(start, new Date());
		} catch {}
		this.currentApp = null;
	}

	/** Track a user seen in the channel. Deduplicates by id, updates name if changed. */
	trackUsers(users: { id: string; name: string }[]) {
		for (const u of users) {
			const existing = this.participants.find(p => p.id === u.id);
			if (existing) {
				existing.name = u.name;
			} else {
				this.participants.push({ id: u.id, name: u.name });
			}
		}
	}

	/** Send a metric entry and reset state for the next session. Only sends if the
	 *  user actually joined a channel — non-channel page visits are not tracked. */
	send() {
		if (this.channels.length === 0) {
			return;
		}

		if (this.currentApp) {
			this.endApp();
		}

		const data: IMetric = {
			id: undefined,
			date: undefined,
			geo: undefined,
			user: this.user,
			seconds: getSeconds(this.enterDate, new Date()),
			location: this.location,
			ad: null,
			referer: this.referer,
			info: {
				apps: this.appMetrics,
				channels: this.channels,
				participants: this.participants
			}
		};

		let config: RequestInit = {
			method: 'POST',
			cache: 'no-cache',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data),
			keepalive: true
		};

		fetch(`${base_api}/metrics`, config).catch(() => {});

		// Reset for any subsequent channel session in the same page lifetime
		this.appMetrics = [];
		this.currentApp = null;
		this.enterDate = new Date();
		this.user = null;
		this.channels = [];
		this.participants = [];
		this.location = document.location.href;
	}
}

export const metrics = new Metrics();

window.addEventListener('beforeunload', () => metrics.send());

